import i18n from "../../../../../constants/i18n";
import { BELONG_TO_A_TRIBE, EDUCATION_LEVEL, FEMALE_WORK_STUDY, HAVING_KIDS, KHATTABAT_MATCHING_RESULTS_MATCH_APP_LANGUAGE, MARITAL_STATUS_FEMALE, MARITAL_STATUS_MALE, RELIGION, RELOCATION, SKIN_COLOR, SMOKING_LEVEL, TYPE_OF_MARIAGE, VEIL, WORK_LEVEL } from "../../../../../constants/picker-entries-constants";
import { ALLOWED_AGES, ALLOWED_HEIGHTS, ALLOWED_WEIGHTS, COUNTRIES } from "../../../../../constants/user-profile";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-store";
import { TEt3PickerSingleValue, TEt3PickerMultipleValue } from "../../../../../TypesNEW";
import PaidUserSelect from "../../shared/paid-user-select";
import CitySearch from "./CitySearch";
import ExcludeSearch from "./ExcludeSearch";
import FormActions from "./FormActions";
import FormSectionWrapper from "./FormSectionWrapper";

const Form = withLiteObserverAndTheme(() => {
  const maleCurrentClient =
    getKhattabatMatchingStore().currentClientInformation.get().gender === "m";


  const shouldShowVeilOptions =
    getKhattabatMatchingStore().isMatchingVeilCriteriaExists.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1510}
      height={0}
      color={""}
      style={{}}
      onClick={() => { }}
    >
      <PaidUserSelect showCount={false} />

      <FormSectionWrapper >
        <Et3Picker
          label={i18n.get("MIN_AGE")}
          options={ALLOWED_AGES}
          value={getKhattabatMatchingStore().minMatchAgeFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMinMatchAgeFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("MAX_AGE")}
          options={ALLOWED_AGES}
          value={getKhattabatMatchingStore().maxMatchAgeFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMaxMatchAgeFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>

      <FormSectionWrapper >
        <Et3Picker
          label={i18n.get("MIN_WEIGHT")}
          options={ALLOWED_WEIGHTS}
          value={getKhattabatMatchingStore().minMatchWeightFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMinMatchWeightFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("MAX_WEIGHT")}
          options={ALLOWED_WEIGHTS}
          value={getKhattabatMatchingStore().maxMatchWeightFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMaxMatchWeightFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>



      <FormSectionWrapper>
        <Et3Picker
          label={i18n.get("MIN_HEIGHT")}
          options={ALLOWED_HEIGHTS}
          value={getKhattabatMatchingStore().minMatchHeightFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMinMatchHeightFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("MAX_HEIGHT")}
          options={ALLOWED_HEIGHTS}
          value={getKhattabatMatchingStore().maxMatchHeightFilter.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMaxMatchHeightFilter(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>

      <FormSectionWrapper>
        <Et3Picker
          label={i18n.get("NATIONALITY")}
          options={COUNTRIES()}
          value={getKhattabatMatchingStore().matchtNationalityFilter.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchNationalityFilter(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <ExcludeSearch
          onClick={getKhattabatMatchingStore().toggleIsChosenNationalitiesExcluded}
          state={getKhattabatMatchingStore().isChosenNationalitiesExcluded.get()}
          isDisabled={getKhattabatMatchingStore().isNationalitiesExcludingDisabled.get()} />

        <Et3Picker
          label={i18n.get("COUNTRY_OF_RESIDENCE")}
          options={COUNTRIES()}
          value={getKhattabatMatchingStore().matchResidenceFilter.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchResidenceFilter(value);
          }}
          isMultiple={true}
          style={{}}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <ExcludeSearch
          onClick={getKhattabatMatchingStore().toggleIsChosenResidenceCountriesExcluded}
          state={getKhattabatMatchingStore().isChosenResidenceCountriesExcluded.get()}
          isDisabled={getKhattabatMatchingStore().isResidenceExcludingDisabled.get()} />
      </FormSectionWrapper>

      <CitySearch />

      <FormSectionWrapper>
        <Et3Picker
          label={i18n.get("TYPE_OF_MARIAGE")}
          options={TYPE_OF_MARIAGE}
          value={getKhattabatMatchingStore().matchMariageType.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMariageState(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("MARITAL_STATUS")}
          options={
            maleCurrentClient ? MARITAL_STATUS_FEMALE : MARITAL_STATUS_MALE
          }
          value={getKhattabatMatchingStore().matchMaritalStatus.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchMaritalStatus(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("HAVING_KIDS")}
          options={HAVING_KIDS}
          value={getKhattabatMatchingStore().matchHavingKids.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMatchHavingKids(value);
          }}
          isMultiple={false}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("WORK_LEVEL")}
          options={WORK_LEVEL}
          value={getKhattabatMatchingStore().matchWork.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchWork(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>

      <FormSectionWrapper>
        <Et3Picker
          label={i18n.get("EDUCATION_LEVEL")}
          options={EDUCATION_LEVEL}
          value={getKhattabatMatchingStore().matchEducation.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchEducation(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("FEMALE_WORK_STUDY")}
          options={FEMALE_WORK_STUDY}
          value={getKhattabatMatchingStore().matchFemaleWorkStudy.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMatchFemaleWorkStudy(value);
          }}
          isMultiple={false}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("SMOKING_LEVEL")}
          options={SMOKING_LEVEL}
          value={getKhattabatMatchingStore().matchSmoking.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMatchSmoking(value);
          }}
          isMultiple={false}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("BELONGS_TO_TRIBE")}
          options={BELONG_TO_A_TRIBE}
          value={getKhattabatMatchingStore().matchBelongsToATribe.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMatchBelongsToATribe(value);
          }}
          isMultiple={false}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>

      <FormSectionWrapper>
        <Et3Picker
          label={i18n.get("RELOCATION")}
          options={RELOCATION}
          value={getKhattabatMatchingStore().matchRelocation.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMatchRelocation(value);
          }}
          isMultiple={false}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        <Et3Picker
          label={i18n.get("SKIN_COLOR")}
          options={SKIN_COLOR}
          value={getKhattabatMatchingStore().matchSkinColor.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchSkinColor(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
        {!shouldShowVeilOptions ? null : (
          <Et3Picker
            label={i18n.get("VEIL")}
            options={VEIL}
            value={getKhattabatMatchingStore().matchFemaleVeil.get()}
            onChoose={(value: TEt3PickerMultipleValue) => {
              getKhattabatMatchingStore().setMatchFemaleVeil(value);
            }}
            isMultiple={true}
            style={{ position: "relative" }}
            onEnter={() => { }}
            onClick={() => { }}
            containerStyle={{}}
          />
        )}
        <Et3Picker
          label={i18n.get("RELIGION")}
          options={RELIGION}
          value={getKhattabatMatchingStore().matchReligion.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchReligion(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>

      <FormSectionWrapper>
        <Et3Picker
          label={i18n.get("MATCH_APP_LANGUAGE")}
          options={KHATTABAT_MATCHING_RESULTS_MATCH_APP_LANGUAGE}
          value={getKhattabatMatchingStore().matchAppLanguage.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getKhattabatMatchingStore().setMatchAppLanguage(value);
          }}
          isMultiple={false}
          style={{ position: "relative" }}
          onEnter={() => { }}
          onClick={() => { }}
          containerStyle={{}}
        />
      </FormSectionWrapper>

      <FormActions />
    </ET3Div>
  );
});

export default Form;
